<script setup lang="ts">
useHead({
  bodyAttrs: {
    class: 'bg-surface-secondary',
  },
})

definePageMeta({
  name: 'laws-index',
  layout: 'default',
  colorMode: 'light',
  theme: 'blurple',
  breadcrumb: {
    label: 'Lover og lovkommentarer',
  },
  title: 'Lover og lovkommentarer',
})

useSeoMeta({
  title: 'Lover og lovkommentarer',
  description: 'Finn lover og lovkommentarer',
})

const route = useRoute<'laws-index'>()

const { lawGroups, isLoading, suspense } = useLawFilters()

if (import.meta.server) {
  await suspense()
}

useTrackLastActivity(() => String(route.meta.title))
</script>

<template>
  <NuxtLayout name="overview-with-bread-crumbs-and-title" page-title="Lover og lovkommentarer" sticky-panel-top>
    <template #background-illustration>
      <IllustrationLoverOgLovkommentarer />
    </template>

    <div class="w-full flex items-start gap-l">
      <StickyContent class="hidden md:flex flex-col shrink-0 max-h-[calc(100dvh-6.5rem)] no-scrollbar overflow-y-auto [--padding-top:0rem]">
        <LawFilterSidebar />
      </StickyContent>

      <h2 class="sr-only">Lover og lovkommentarer</h2>

      <div class="flex-1 min-w-0">
        <StickyContent class="bg-white z-10 pt-m pb-2xs">
          <LawListHeader />
        </StickyContent>
        <LawGrid :groups="lawGroups" :is-loading="isLoading" />
      </div>
    </div>
  </NuxtLayout>
</template>
